<template>
  <!--
      作者 luoyiming
      时间：2019-10-26
      描述：设置-商城设置
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">商城设置</div>
      <el-form-item label="商城名称" :rules="[{ required: true, message: ' ' }]" prop="name">
        <el-input v-model="form.name" placeholder="商城名称" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="配送方式">
        <el-checkbox-group v-model="form.deliveryType">
          <el-checkbox v-for="(item, index) in all_type" :label="item.value" :key="index">{{ item.name }}</el-checkbox>
        </el-checkbox-group>
        <div class="tips">注：配送方式至少选择一个</div>
      </el-form-item>
      <div class="common-form">日志记录</div>
      <el-form-item label="是否记录查询日志" prop="customer">
        <el-checkbox v-model="form.isGetLog">是否记录查询日志</el-checkbox>
        <div class="tips">如果记录，日志量会有点大</div>
      </el-form-item>
      <div class="common-form">物流查询api</div>
      <el-form-item label="快递100 Customer" :rules="[{ required: true, message: ' ' }]" prop="kuaiDi100.customer">
        <el-input v-model="form.kuaiDi100.customer" placeholder="" class="max-w460"></el-input>
        <div class="tips">用于查询物流信息,<el-link :underline="false" href="https://www.kuaidi100.com/openapi/" target="_blank"
            type="primary">快递100申请</el-link>
        </div>
      </el-form-item>
      <el-form-item label="快递100 Key" :rules="[{ required: true, message: ' ' }]" prop="kuaiDi100.key">
        <el-input v-model="form.kuaiDi100.key" placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <div class="common-form">政策协议</div>
      <el-form-item label="服务协议" :rules="[{ required: true, message: ' ' }]" prop="policy.service">
        <el-input v-model="form.policy.service" placeholder="" class="max-w460"></el-input>
        <div class="tips">进入app和登录、注册页面显示</el-link>
        </div>
      </el-form-item>
      <el-form-item label="隐私政策" :rules="[{ required: true, message: ' ' }]" prop="policy.privacy">
        <el-input v-model="form.policy.privacy" placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <div class="common-form">客服电话</div>
      <el-form-item label="客服电话" :rules="[{ required: true, message: ' ' }]" prop="phone">
        <el-input v-model="form.phone" placeholder="客服电话" class="max-w460"></el-input>
      </el-form-item>
      <div class="common-form">订单客服电话</div>
      <el-form-item label="订单客服电话" :rules="[{ required: true, message: ' ' }]" prop="orderPhone">
        <el-input v-model="form.orderPhone" placeholder="订单客服电话" class="max-w460"></el-input>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--上传图片-->
    <div class="common-form">邀请链接背景图</div>
    <!--    <el-upload class="avatar-uploader" action="string" :show-file-list="false"
       :http-request="UploadImage" :before-upload="beforeAvatarUpload" accept="image/*">
      <img v-if="form.imageUrl" :src="form.imageUrl" class="avatar">
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload> -->
    <!-- <Upload v-if="isupload" :isupload="isupload" :config="{ total: 3 }" @returnImgs="returnImgsFunc"></Upload> -->
    <div class="draggable-list" style="margin-bottom: 50px;">
      <draggable class="wrapper" v-model="form.model.image">
        <transition-group>
          <div class="item" v-for="(item, index) in form.model.image" :key="item.filePath">
            <img v-img-url="item.filePath" />
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
          </div>
        </transition-group>
      </draggable>
      <div class="item img-select" @click="openProductUpload('image', 'image')"><i class="el-icon-plus"></i></div>
    </div>
    <!--商品图片组件-->
    <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
  import FileApi from '@/api/file.js';
  import SettingApi from '@/api/setting.js';
  import Upload from '@/components/file/Upload';
  import draggable from 'vuedraggable';
  import {
    formatModel
  } from '@/utils/base.js';
  export default {
    components: {
      Upload,
      draggable
    },
    data() {
      return {
        isProductUpload: false,
        /*是否正在加载*/
        loading: false,
        /*form表单数据*/
        form: {
          model: {
            /*商品图片*/
            image: []
          },
          name: '',
          phone: '',
          orderPhone: '',
          kuaiDi100: {
            customer: '',
            key: ''
          },
          deliveryType: [],
          isGetLog: 0,
          policy: {
            service: '',
            privacy: ''
          },
          imageUrl: ''
        },
        all_type: [],
        delivery_type: [],
        /*是否打开图片选择*/
        isupload: true,
        imageUrl: '', // 上传图片
      };
    },
    created() {
      this.getParams()
    },

    methods: {
      /*获取配置数据*/
      getParams() {
        let self = this;
        SettingApi.storeDetail({}, true).then(res => {
            self.form = formatModel(self.form, res.data);
            self.all_type = res.data.allType;
            self.loading = false;
          })
          .catch(error => {
            // console.log(error);
          });

      },


      /*提交*/
      onSubmit() {
        let self = this;
        let params = this.form;
        if (params.deliveryType.length < 1) {
          self.$message({
            message: '配送方式至少选择一种！',
            type: 'warning'
          });
          return;
        }

        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            SettingApi.editStore(params, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，商城设置成功',
                  type: 'success'
                });
                self.$router.push('/setting/store/index');
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });

      },

      // 上传图片
      UploadImage(param) {
        let self = this;
        const loading = this.$loading({
          lock: true,
          text: '文件上传中,请等待',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        const formData = new FormData();
        formData.append('iFile', param.file);
        formData.append("groupId", 0);
        formData.append("fileType", 'image');
        FileApi.uploadFile(formData)
          .then(response => {
            self.form.imageUrl = response.data
            loading.close();
          })
      },
      beforeAvatarUpload(file) {
        const typeArry = ['.jpeg', '.jpg', '.png', '.bmp', '.JPG', '.PNG', '.BMP', '.gif', '.GIF'];
        const type = file.name.substring(file.name.lastIndexOf('.'));
        const isImage = typeArry.indexOf(type) > -1;
        const isLt2M = file.size / 1024 / 1024 < 10;

        if (!isImage) {
          this.$message.error('上传文件必须为图片');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 10MB!');
        }
        return isImage && isLt2M;
      },
      /*删除商品图片*/
      deleteImg(index) {
        this.form.model.image.splice(index, 1);
      },
      /*打开上传图片*/
      openProductUpload: function(file_type, file_name) {
        this.file_name = file_name;
        if (file_type == 'image') {
          this.config = {
            total: 9,
            fileType: 'image'
          };
        } else {
          this.config = {
            total: 1,
            fileType: 'video'
          };
        }
        this.isProductUpload = true;
      },
      /*上传商品图片*/
      returnProductImgsFunc(e) {
        if (e != null) {
          if (this.file_name == 'video') {
            this.form.model.videoId = e[0].fileId;
            this.form.model.videoFilePath = e[0].filePath;
          } else if (this.file_name == 'image') {
            let imgs = this.form.model.image.concat(e);
            // 兼容后端
            for (let i = 0; i < imgs.length; i++) {
              if (typeof(imageId) == "undefined") {
                this.$set(imgs[i], 'imageId', imgs[i].fileId);
              }
            }
            this.$set(this.form.model, 'image', imgs);
          } else if (this.file_name == 'poster') {
            this.form.model.posterId = e[0].fileId;
            this.form.model.posterFilePath = e[0].filePath;
          }
        }
        this.isProductUpload = false;
      }
    }

  };
</script>
<style>
  .tips {
    color: #ccc;
  }

  .avatar-uploader {
    margin: 0 0 30px 150px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    /* height: 178px; */
    display: block;
  }

  .draggable-list .wrapper>span {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .draggable-list .img-select {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #dddddd;
    font-size: 30px;
  }

  .draggable-list .img-select i {
    color: #409eff;
  }

  .draggable-list .item img {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-height: 100%;
    max-width: 100%;
  }

  .draggable-list .item:hover .delete-btn {
    display: block;
  }

  .draggable-list .item img {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-height: 100%;
    max-width: 100%;
  }

  .draggable-list .delete-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 16px;
    background: red;
    line-height: 16px;
    font-size: 16px;
    color: #ffffff;
    display: none;
  }

  .draggable-list .item {
    position: relative;
    width: 110px;
    height: 110px;
    margin-top: 10px;
    margin-right: 10px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #dddddd;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/store/index.vue